<section>
<header>
    <div class="btn_header" id="header_btn">
        <div class="header_logo" id="headerLogo" routerLink=""></div>
          <button class="navbar-toggler" id="trigger-overlay" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
            <div class="menu_icon"></div>
          </button>
      </div>
      <div class="">
      <nav class="navbar navbar-expand-lg bg-body-tertiary navbar1" id="mobNav">
        <a href="" class="a_kidzee_logo">
        <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/kidzee_logo.svg" width="15%" class="kidzee_logo_img" alt="">
      </a>
          <div class="collapse navbar-collapse nav_body" id="navbarNavDropdown">
             <ul class="navbar-nav ul_content">
              <li class="nav-item">
                <a href="" class="nav-link active menu1" aria-current="page">Home</a>
              </li>
           
              <li class="nav-item">
                <a class="nav-link active menu1" aria-current="page" (click)="gotPage('aboutUs')">About Us</a>
              </li>
              <li class="nav-item">
                <a class="nav-link menu1" aria-current="page" (click)="gotPage('whyKidzee')">Why Kidzee?</a>
              </li>
              
              <li class="nav-item">
                <a class="nav-link menu1" aria-current="page" (click)="gotPage('award')">Awards and Recognitions</a>
              </li>
              <li class="nav-item">
                <a class="nav-link menu5" aria-current="page" (click)="gotPage('faqs')">FAQs</a>
              </li>
              <li class="nav-item">
                <a class="nav-link menu" aria-current="page" (click)="gotPage('testimonials')">Testimonials</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" aria-current="page" (click)="gotPage('contactUs')">Contact Us</a>
              </li>
      
            </ul>
          </div>
      </nav>
      </div>
      <div class="whiteHeader" id="whiteHeader">
          <nav class="nav navbar navbar-expand-lg">
              <div class="container-fluid">
                <div class="navbar-brand">
                </div>
                <div class="menu_icon" data-bs-toggle="collapse" data-bs-target="#navbarNav"></div>
                <div class="collapse navbar-collapse " id="navbarNav">
                  <a href="" class="a_kidzee_logo">
                  <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/kidzee_logo.svg" width="15%" class="kidzee_logo_img" alt="">
                </a>
                  <ul class="navbar-nav ul_content">
                    <li class="nav-item">
                      <a href="#home" class="nav-link active menu1" aria-current="page" href="">Home</a>
                    </li>
                    
                    <li class="nav-item">
                        <a (click)="scrollTo('aboutUs')" class="nav-link active menu1" aria-current="page">About Us</a>
                      </li>
                    <li class="nav-item">
                      <a (click)="scrollTo('whyKidzee')" class="nav-link menu1" aria-current="page">Why Kidzee?</a>
                    </li>
                    <li class="nav-item">
                      <a (click)="scrollTo('awardAndRecognitions')" class="nav-link menu5" aria-current="page">Awards and Recognitions</a>
                    </li>
                    <li class="nav-item">
                      <a (click)="scrollTo('faqs')" class="nav-link menu" aria-current="page">FAQs</a>
                    </li>
                    <li class="nav-item">
                      <a (click)="scrollTo('testimonials')" class="nav-link" aria-current="page">Testimonials</a>
                    </li>
                    <li class="nav-item">
                        <a (click)="scrollTo('contactUs')" class="nav-link" aria-current="page">Contact Us</a>
                      </li>
                  </ul>
                </div>
              </div>
            </nav>
      
      </div> 
    </header>
 
 
    <div class="banner_content">
        <div class="banner_content_slider">
            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/banner/frinch_bg.png" width="100%" class="mob_franchise" alt="">

            <div class="form_content">
                <div class="row flex-column-reverse flex-lg-row">
                    <div class="col-md-6">
                    </div>
                    <div class="col-md-6">
                <!-- <app-franchise-form></app-franchise-form>     -->
                <form action="" [formGroup]="admissionForm">
                    <div class="form">
                        <div class="form_title">Enquire Now</div>
                        <div class="form-group mt-2">
                            <input type="text" class="form-control" placeholder="First Name*"
                                formControlName="fname"
                                [ngClass]="{ 'is-invalid': submitted && f.fname.errors }">
                            <div *ngIf="submitted && f.fname.errors" class="invalid-feedback">
                                <span class="text-danger msg_txt"
                                    *ngIf="(f.fname.touched || submitted) && f.fname.errors?.required">
                                    First name is required
                                </span>
                            </div>
                        </div>
                        <div class="form-group mt-2">
                            <input type="text" class="form-control" placeholder="Last Name*"
                                formControlName="lname"
                                [ngClass]="{ 'is-invalid': submitted && f.lname.errors }">
                            <div *ngIf="submitted && f.lname.errors" class="invalid-feedback">
                                <span class="text-danger msg_txt"
                                    *ngIf="(f.lname.touched || submitted) && f.lname.errors?.required">
                                    Last name is required
                                </span>
                            </div>
                        </div>
                        <div class="form-group mt-2">
                            <input type="text" class="form-control" placeholder="Email*"
                                formControlName="email"
                                [ngClass]="{ 'is-invalid': submitted && f.email.errors }">
                            <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                <span class="text-danger msg_txt"
                                    *ngIf="(f.email.touched || submitted) && f.email.errors?.required">
                                    Email is required
                                </span>
                                <span class="text-danger msg_txt"
                                    *ngIf="f.email.touched && f.email.errors?.email">
                                    Enter a valid email address
                                </span>
                            </div>
                        </div>
                        <div class="form-group mt-2">
                            <input type="text" class="form-control" placeholder="Mobile*"
                                (keyup)="getMobileNO();" formControlName="mobile"
                                [ngClass]="{ 'is-invalid': submitted && f.mobile.errors }">
                            <div *ngIf="submitted && f.mobile.errors" class="invalid-feedback msg_txt">
                                <span *ngIf="f.mobile.errors?.required">Mobile is required.</span>
                                <span *ngIf="f.mobile.errors?.pattern">Please, Enter 10 digit Mobile.</span>
                            </div>
                            <div *ngIf="otpInput" class="validMsg">OTP sent successfully</div>
                        </div>
                        <div class="form-group mt-2" *ngIf="otpInput">
                            <input type="text" class="form-control" placeholder="Enter otp*"
                                (keyup)="verifyOTP();" formControlName="otp"
                                [ngClass]="{ 'is-invalid': submitted && f.otp.errors }">
                            <div *ngIf="submitted && f.otp.errors" class="invalid-feedback msg_txt">
                                <span *ngIf="f.otp.errors?.required">OTP is required.</span>
                            </div>
                            <div *ngIf="otp_ValidMsg" class="validMsg">otp verified successfully</div>
                            <div *ngIf="otp_inValidMsg" class="inValidMsg msg_txt">please enter valid otp</div>
                        </div>
                        <div class="form-group mt-2">
                            <input type="text" class="form-control" placeholder="Pin Code*"
                                formControlName="pinCode"
                                [ngClass]="{ 'is-invalid': submitted && f.pinCode.errors }">
                            <div *ngIf="submitted && f.pinCode.errors" class="invalid-feedback msg_txt">
                                <span *ngIf="f.pinCode.errors?.required">Pin code is required.</span>
                                <span *ngIf="f.pinCode.errors?.pattern">Please, Enter 6 digit
                                    pincode.</span>
                            </div>
                        </div>
                
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group mt-2">
                                    <select name="" id="" class="form-control" formControlName="state"
                                        (change)="selectState($event)"
                                        [ngClass]="{ 'is-invalid': submitted && f.state.errors }">
                                        <option value="">State/District</option>
                                        <option value="{{state.State_Name}}"
                                            *ngFor="let state of stateList">
                                            {{state.State_Name}}</option>
                                    </select>
                                    <div *ngIf="submitted && f.state.errors" class="invalid-feedback">
                                        <span class="text-danger msg_txt"
                                            *ngIf="(f.state.touched || submitted) && f.state.errors?.required">
                                            State/District is required
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group mt-2">
                                    <select name="" id="" class="form-control" formControlName="city"
                                        (change)="selectCity($event)"
                                        [ngClass]="{ 'is-invalid': submitted && f.city.errors }">
                                        <option value="">City</option>
                                        <option value="{{city.City_Name}}" *ngFor="let city of cityList">
                                            {{city?.City_Name}}</option>
                                    </select>
                                    <div *ngIf="submitted && f.city.errors" class="invalid-feedback">
                                        <span class="text-danger msg_txt"
                                            *ngIf="(f.city.touched || submitted) && f.city.errors?.required">
                                            City is required
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                
                
                        <div class="form-group mt-2">
                            <div class="form-check">
                                <input class="form-check-input" checked disabled type="checkbox" value=""
                                    id="flexCheckDefault">
                                <label class="form-check-label" for="flexCheckDefault">
                                    I state that I am ready with a min investment of INR 15 - 16 Lacs* & a
                                    min
                                    space
                                    of 2000-3000 sqft, and have read, understood and accepted your Privacy
                                    Policy
                                    and the Terms
                                </label>
                            </div>
                        </div>
                
                        <div class="form-group mt-2 d-flex justify-content-center">
                            <button class="submit_btn" (click)="validationForm();">Submit</button>
                        </div>
                    </div>
                </form>
                </div>
                </div>
            </div>
           
            <div class="counter_list_content">
                <div class="row">
                    <div class="col-md-3">
                        <div class="counter_card">
                            <div class="counter_img text-center">
                             <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/kidzee-partner/centers.png" alt="">
                            </div>
                            <div class="counter_no text-center">
                                2,000+
                            </div>
                            <div class="counter_text text-center text-white">
                                Centers
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="counter_card">
                            <div class="counter_img text-center">
                             <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/kidzee-partner/cities.png" alt="">
                            </div>
                            <div class="counter_no text-center">
                                750+
                            </div>
                            <div class="counter_text text-center text-white">
                                Cities
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="counter_card">
                            <div class="counter_img text-center">
                             <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/kidzee-partner/years.png" class="years_icon" alt="">
                            </div>
                            <div class="counter_no text-center">
                                20+
                            </div>
                            <div class="counter_text text-center text-white">
                                Years of Legacy
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="counter_card">
                            <div class="counter_img text-center">
                             <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/kidzee-partner/students.png" alt="">
                            </div>
                            <div class="counter_no text-center">
                                1.4+
                            </div>
                            <div class="counter_text text-center text-white">
                                Million Students
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="subMenu_content">
            <app-sub-menu></app-sub-menu>
        </div>
    </div>

   

    <div class="mobile_res">
        <div class="mobile_form">
        <!-- <app-franchise-form></app-franchise-form>  -->
        <form action="" [formGroup]="admissionForm">
            <div class="form">
                <div class="form_title">Enquire Now</div>
                <div class="form-group mt-2">
                    <input type="text" class="form-control" placeholder="First Name*"
                        formControlName="fname"
                        [ngClass]="{ 'is-invalid': submitted && f.fname.errors }">
                    <div *ngIf="submitted && f.fname.errors" class="invalid-feedback">
                        <span class="text-danger msg_txt"
                            *ngIf="(f.fname.touched || submitted) && f.fname.errors?.required">
                            First name is required
                        </span>
                    </div>
                </div>
                <div class="form-group mt-2">
                    <input type="text" class="form-control" placeholder="Last Name*"
                        formControlName="lname"
                        [ngClass]="{ 'is-invalid': submitted && f.lname.errors }">
                    <div *ngIf="submitted && f.lname.errors" class="invalid-feedback">
                        <span class="text-danger msg_txt"
                            *ngIf="(f.lname.touched || submitted) && f.lname.errors?.required">
                            Last name is required
                        </span>
                    </div>
                </div>
                <div class="form-group mt-2">
                    <input type="text" class="form-control" placeholder="Email*"
                        formControlName="email"
                        [ngClass]="{ 'is-invalid': submitted && f.email.errors }">
                    <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                        <span class="text-danger msg_txt"
                            *ngIf="(f.email.touched || submitted) && f.email.errors?.required">
                            Email is required
                        </span>
                        <span class="text-danger msg_txt"
                            *ngIf="f.email.touched && f.email.errors?.email">
                            Enter a valid email address
                        </span>
                    </div>
                </div>
                <div class="form-group mt-2">
                    <input type="text" class="form-control" placeholder="Mobile*"
                        (keyup)="getMobileNO();" formControlName="mobile"
                        [ngClass]="{ 'is-invalid': submitted && f.mobile.errors }">
                    <div *ngIf="submitted && f.mobile.errors" class="invalid-feedback msg_txt">
                        <span *ngIf="f.mobile.errors?.required">Mobile is required.</span>
                        <span *ngIf="f.mobile.errors?.pattern">Please, Enter 10 digit Mobile.</span>
                    </div>
                    <div *ngIf="otpInput" class="validMsg">OTP sent successfully</div>
                </div>
                <div class="form-group mt-2" *ngIf="otpInput">
                    <input type="text" class="form-control" placeholder="Enter otp*"
                        (keyup)="verifyOTP();" formControlName="otp"
                        [ngClass]="{ 'is-invalid': submitted && f.otp.errors }">
                    <div *ngIf="submitted && f.otp.errors" class="invalid-feedback msg_txt">
                        <span *ngIf="f.otp.errors?.required">OTP is required.</span>
                    </div>
                    <div *ngIf="otp_ValidMsg" class="validMsg">otp verified successfully</div>
                    <div *ngIf="otp_inValidMsg" class="inValidMsg msg_txt">please enter valid otp</div>
                </div>
                <div class="form-group mt-2">
                    <input type="text" class="form-control" placeholder="Pin Code*"
                        formControlName="pinCode"
                        [ngClass]="{ 'is-invalid': submitted && f.pinCode.errors }">
                    <div *ngIf="submitted && f.pinCode.errors" class="invalid-feedback msg_txt">
                        <span *ngIf="f.pinCode.errors?.required">Pin code is required.</span>
                        <span *ngIf="f.pinCode.errors?.pattern">Please, Enter 6 digit
                            pincode.</span>
                    </div>
                </div>
        
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group mt-2">
                            <select name="" id="" class="form-control" formControlName="state"
                                (change)="selectState($event)"
                                [ngClass]="{ 'is-invalid': submitted && f.state.errors }">
                                <option value="">State/District</option>
                                <option value="{{state.State_Name}}"
                                    *ngFor="let state of stateList">
                                    {{state.State_Name}}</option>
                            </select>
                            <div *ngIf="submitted && f.state.errors" class="invalid-feedback">
                                <span class="text-danger msg_txt"
                                    *ngIf="(f.state.touched || submitted) && f.state.errors?.required">
                                    State/District is required
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mt-2">
                            <select name="" id="" class="form-control" formControlName="city"
                                (change)="selectCity($event)"
                                [ngClass]="{ 'is-invalid': submitted && f.city.errors }">
                                <option value="">City</option>
                                <option value="{{city.City_Name}}" *ngFor="let city of cityList">
                                    {{city.City_Name}}</option>
                            </select>
                            <div *ngIf="submitted && f.city.errors" class="invalid-feedback">
                                <span class="text-danger msg_txt"
                                    *ngIf="(f.city.touched || submitted) && f.city.errors?.required">
                                    City is required
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
        
        
                <div class="form-group mt-2">
                    <div class="form-check">
                        <input class="form-check-input" checked disabled type="checkbox" value=""
                            id="flexCheckDefault">
                        <label class="form-check-label" for="flexCheckDefault">
                            I state that I am ready with a min investment of INR 15 - 16 Lacs* & a
                            min
                            space
                            of 2000-3000 sqft, and have read, understood and accepted your Privacy
                            Policy
                            and the Terms
                        </label>
                    </div>
                </div>
        
                <div class="form-group mt-2 d-flex justify-content-center">
                    <button class="submit_btn" (click)="validationForm();">Submit</button>
                </div>
            </div>
        </form>
    </div>
      
    <div class="counter_list_content">
        <div class="row">
            <div class="col-6">
                <div class="counter_card">
                    <div class="counter_img text-center">
                     <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/kidzee-partner/centers.png" alt="">
                    </div>
                    <div class="counter_no text-center">
                        2,000+
                    </div>
                    <div class="counter_text text-center text-white">
                        Centers
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="counter_card">
                    <div class="counter_img text-center">
                     <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/kidzee-partner/cities.png" alt="">
                    </div>
                    <div class="counter_no text-center">
                        750+
                    </div>
                    <div class="counter_text text-center text-white">
                        Cities
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="counter_card">
                    <div class="counter_img text-center">
                     <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/kidzee-partner/years.png" class="years_icon" alt="">
                    </div>
                    <div class="counter_no text-center">
                        20+
                    </div>
                    <div class="counter_text text-center text-white">
                        Years of Legacy
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="counter_card">
                    <div class="counter_img text-center">
                     <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/kidzee-partner/students.png" alt="">
                    </div>
                    <div class="counter_no text-center">
                        1.4+
                    </div>
                    <div class="counter_text text-center text-white">
                        Million Students
                    </div>
                </div>
            </div>
        </div>
    </div>
       
    </div>
</section>

<div class="kidzee_partner_content">
 <!-- <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/kidzee_partner_bg.png" width="100%" class="kidzee_banner" alt=""> -->
   
<section id="aboutUs">
    <div class="mainDiv">
        <!-- <app-home-about-us></app-home-about-us> -->
        <div class="aboutUs">
            <div class="sub_content padding_top">
            <div class="row flex-column-reverse flex-lg-row">
                <div class="col-md-6">
                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/scale.png" class="scale_img" alt="">
                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/bag_img.png" class="bag_img_content" alt="">
                    <div class="monkeyContent">
                        <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/kidzee_school_img.png" loading="lazy" alt="" class="monkey1">
                        <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/mouse_img.png" class="mouse_img_content" alt="">
                    </div>
                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/pen.png" class="pen_img_content" alt="">
                </div>
                <div class="col-md-6">
                    <div class="text_content">
                        <div class="right_content1">
                            <h1 class="title">
                                About Us<br>
                                <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/bottom_img.png" class="bottom_img_content" alt="">
                            </h1>
                            <div class="subTitle mt-2">
                                Kidzee Preschool – India’s Leading Preschool Franchise
                            </div>
                          
                            <div class="paragraph_content mt-2">
                                <p>Kidzee Preschool is India’s largest preschool chain, with a strong presence across India and Nepal, backed by Zee Learn Ltd. With over 20 years of expertise in early childhood education (ECCE), Kidzee has nurtured 1.5 million+ children, setting industry benchmarks in preschool education. Recognized as a trusted preschool brand in India, Kidzee provides a proven franchise model that ensures success for aspiring preschool business owners.</p>
                               <p>Our Kidzee franchise partners benefit from our unique PéNTEMiND pedagogy, structured curriculum, and expertly designed teaching methodologies. From selecting prescribed books and play-based learning activities to structured teacher training programs, we ensure a seamless and enriching educational experience.</p>
                                <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/fruit_img.png" class="fruit_img_content" alt="">
                                </div>   
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="paragraph_content">
                    <p>Starting a preschool business requires careful research, planning, and execution. At Kidzee, we offer end-to-end support, including pre-opening assistance, operational guidance, and ongoing business support, ensuring a smooth journey for our franchise owners. Join the Kidzee preschool franchise and be a part of India’s most successful and profitable preschool network.</p>  
                </div>   
                </div>
            </div>
        </div>
        </div>
    </div>
</section>
<section  id="whyKidzee">
    <div class="sub_content">
    <div class="kidzee_advantage">
        <h1 class="title text-center">
            The Kidzee Advantage<br>
            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/bottom_img.png" class="kidzee_bottom_img" alt="">
        </h1>
        <div class="row">
            <div class="col-md-4">
                <a href="#popup1" (click)="openPopup($event,'1')">
                <div class="advantage_content">
                    <div class="row">
                        <div class="col-2 d-flex justify-content-center align-items-center">
                            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/kad1.png" alt="">
                        </div>
                        <div class="col-10 d-flex justify-content-start align-items-center">
                           
                            <div class="advantage_text">
                                India’s largest pre-school chain
                            </div>
                       
                        </div>
                    </div>
                </div>
            </a>
            </div>
            <div class="col-md-4">
                <a href="#popup2" (click)="openPopup($event,'2')">
                <div class="advantage_content">
                    <div class="row">
                        <div class="col-2 d-flex justify-content-center align-items-center">
                            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/kad2.png" alt="">
                        </div>
                        <div class="col-10 d-flex justify-content-start align-items-center">
                            <div class="advantage_text">
                                Proven Business Model
                            </div>
                            
                        </div>
                    </div>
                </div>
            </a>
            </div>
            <div class="col-md-4">
                <a href="#popup3" (click)="openPopup($event,'3')">
                <div class="advantage_content">
                    <div class="row">
                        <div class="col-2 d-flex justify-content-center align-items-center">
                            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/kad3.png" alt="">
                        </div>
                        <div class="col-10 d-flex justify-content-start align-items-center">
                            
                            <div class="advantage_text">
                                Market leader with a strong brand recall and brand lineage of 20 years
                            </div>
                            
                        </div>
                    </div>
                </div>
            </a>
            </div>

            <div class="col-md-4">
                <a href="#popup4" (click)="openPopup($event,'4')">
                <div class="advantage_content">
                    <div class="row">
                        <div class="col-2 d-flex justify-content-center align-items-center">
                            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/kad4.png" alt="">
                        </div>
                        <div class="col-10 d-flex justify-content-start align-items-center">
                           
                            <div class="advantage_text">
                                Most awarded pre-school in the category
                            </div>
                            
                        </div>
                    </div>
                </div>
            </a>
            </div>
            <div class="col-md-4">
                <a href="#popup5" (click)="openPopup($event,'5')">
                <div class="advantage_content">
                    <div class="row">
                        <div class="col-2 d-flex justify-content-center align-items-center">
                            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/kad5.png" alt="">
                        </div>
                        <div class="col-10 d-flex justify-content-start align-items-center">
                            
                            <div class="advantage_text">
                                4 layers of support
                            </div>
                       
                        </div>
                    </div>
                </div>
            </a>
            </div>
            <div class="col-md-4">
                <a href="#popup6" (click)="openPopup($event,'6')">
                <div class="advantage_content">
                    <div class="row">
                        <div class="col-2 d-flex justify-content-center align-items-center">
                            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/kad6.png" alt="">
                        </div>
                        <div class="col-10 d-flex justify-content-start align-items-center">
                           
                            <div class="advantage_text">
                                Most advanced curriculum
                            </div>
                           
                        </div>
                    </div>
                </div>
            </a>
            </div>
            <div class="col-md-4">
                <a href="#popup7" (click)="openPopup($event,'7')">
                <div class="advantage_content">
                    <div class="row">
                        <div class="col-2 d-flex justify-content-center align-items-center">
                            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/kad7.png" alt="">
                        </div>
                        <div class="col-10 d-flex justify-content-start align-items-center">
                            
                            <div class="advantage_text">
                                Best-in-class pedagogy
                            </div>
                            
                        </div>
                    </div>
                </div>
            </a>
            </div>
            <div class="col-md-4">
                <a href="#popup8" (click)="openPopup($event,'8')">
                <div class="advantage_content">
                    <div class="row">
                        <div class="col-2 d-flex justify-content-center align-items-center">
                            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/kad8.png" alt="">
                        </div>
                        <div class="col-10 d-flex justify-content-start align-items-center">
                            
                            <div class="advantage_text">
                                Operational and Academic Support
                            </div>
                           
                        </div>
                    </div>
                </div>
            </a>
            </div>
            <div class="col-md-4">
                <a href="#popup9" (click)="openPopup($event,'9')">
                <div class="advantage_content">
                    <div class="row">
                        <div class="col-2 d-flex justify-content-center align-items-center">
                            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/kad9.png" alt="">
                        </div>
                        <div class="col-10 d-flex justify-content-start align-items-center">
                            
                            <div class="advantage_text">
                                Training
                            </div>
                          
                        </div>
                    </div>
                </div>
            </a>
            </div>
            <div class="col-md-4">
                <a href="#popup10" (click)="openPopup($event,'10')">
                <div class="advantage_content">
                    <div class="row">
                        <div class="col-2 d-flex justify-content-center align-items-center">
                            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/kad10.png" alt="">
                        </div>
                        <div class="col-10 d-flex justify-content-start align-items-center">
                           
                            <div class="advantage_text">
                                e-Kidzee
                            </div>
                            
                        </div>
                    </div>
                </div>
            </a>
            </div>
            <div class="col-md-4">
                <a href="#popup11" (click)="openPopup($event,'11')">
                <div class="advantage_content">
                    <div class="row">
                        <div class="col-2 d-flex justify-content-center align-items-center">
                            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/kad11.png" alt="">
                        </div>
                        <div class="col-10 d-flex justify-content-start align-items-center">
                           
                            <div class="advantage_text">
                                Layout Plan
                            </div>
                       
                        </div>
                    </div>
                </div>
            </a>
            </div>
            <div class="col-md-4">
                <a href="#popup12" (click)="openPopup($event,'12')">
                <div class="advantage_content">
                    <div class="row">
                        <div class="col-2 d-flex justify-content-center align-items-center">
                            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/kad12.png" alt="">
                        </div>
                        <div class="col-10 d-flex justify-content-start align-items-center"> 
                            <div class="advantage_text">
                                Project Support
                            </div>
                        </div>
                    </div>
                </div>
            </a>
            </div>
        </div>
    </div>
    </div>
</section>

<section>
    <div class="sub_content mt-5 padding_top">
        <h1 class="title text-center">
            Timeline<br>
            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/bottom_img.png" class="kidzee_bottom_img" alt="">
        </h1>
        <div class="timeline_img">
            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/timeline_img.png" width="100%" alt="">
        </div>
        <div class="timeline_img_mobile">
           <div class="paper_img d-flex justify-content-center align-items-center">
            <div>
            <h5 class="text-center">Day 1</h5>
            <div class="paper_sub_text">Enquire with us<br>
                and fix a meeting</div>
           </div>
        </div>
        <div class="paper_img d-flex justify-content-center align-items-center">
            <div>
            <h5 class="text-center">Day 5</h5>
            <div class="paper_sub_text">Finalise your<br>
                pre-school location</div>
           </div>
        </div>
        <div class="paper_img d-flex justify-content-center align-items-center">
            <div>
            <h5 class="text-center">Day 22</h5>
            <div class="paper_sub_text">Sign up with us</div>
           </div>
        </div>
        <div class="paper_img d-flex justify-content-center align-items-center">
            <div>
            <h5 class="text-center">Day 45</h5>
            <div class="paper_sub_text">Your Kidzee pre-school<br>
                is operational</div>
           </div>
        </div>
        </div>
    </div>
    </section>

<section id="awardAndRecognitions">
    <div class="award_bg_img">
        <div class="mainDiv2">
            <div class="dayCareContent">
                <div class="row">
                    <div class="col-md-6">
                        <div class="dayCareText">
                            <div class="right_content1">
                                <h1 class="title day_care_color">
                                    Awards and<br>Recognitions <br>
                                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/obj_bg.png" class="bottom_img_content" alt="">
                                </h1>
                                <h6 class="text-white">India's most recognised
                                    Pre-school Franchise</h6>
                                <div class="paragraph_content mt-2 white_color">
                                        <ul class="nav nav-tabs" id="myTab" role="tablist">
                                            <li class="nav-item" role="presentation">
                                              <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">2024</button>
                                            </li>
                                            <li class="nav-item" role="presentation">
                                              <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">2023</button>
                                            </li>
                                            <li class="nav-item" role="presentation">
                                              <button class="nav-link" id="contact-tab" data-bs-toggle="tab" data-bs-target="#contact" type="button" role="tab" aria-controls="contact" aria-selected="false">2022</button>
                                            </li>
                                            <li class="nav-item" role="presentation">
                                                <button class="nav-link" id="befor-tab" data-bs-toggle="tab" data-bs-target="#befor" type="button" role="tab" aria-controls="befor" aria-selected="false">and Before</button>
                                              </li>
                                          </ul>
                                          <div class="tab-content" id="myTabContent">
                                            <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                                                <ul class="tab_info_content">
                                                    <li>Best Education Brands Zee Learn – 2024</li>
                                                    <li>Outstanding Supply Chain Vendor Management, CII Scale Award</li>
                                                </ul>
                                            </div>
                                            <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                                                <ul class="tab_info_content">
                                                    <li>Franchise Awards 2023 - Franchisor of the year Kidzee Preschool Kidzee</li>
                                                    <li>Education Innovation Award 2023 – Preschool chain of the year Kidzee (National)</li>
                                                    <li>Tech Circle – Business Transformation Award 2023</li>
                                                    <li>Radio City Business Titans – Excellence in The Category of Preschool 2023</li>
                                                    <li>Forbes DGEM – Listed as 200 Select Companies with Global Business Potential 2023</li>
                                                    <li>The Fortune Leadership Awards – Education Brand of the Year 2023</li>
                                                </ul>
                                            </div>
                                            <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
                                                <ul class="tab_info_content">
                                                    <li>Kidzee recognised as India's Most Trusted Preschool category in TRA'S Brand Trust Report, 2022</li>
                                                    <li>Ranked amongst the Top 100 Franchise Opportunities for the year 2022 by Franchise India</li>
                                                </ul>
                                            </div>
                                            <div class="tab-pane fade" id="befor" role="tabpanel" aria-labelledby="befor-tab">
                                                <ul class="tab_info_content">
                                                    <li>Recognised as Leading Preschool Chain (National) at the 17th World Education Summit & Awards 2020</li>
                                                    <li>Innovation in Preschool Pedagogy at the 17th World Education Summit & Awards 2020</li>
                                                    <li>Innovation in the Curriculum in Early Childhood Development at the 17th World Education Summit & Awards 2020</li>
                                                    <li>National Early Child playschool chain of the year award at the 10th Annual Indian Education Award 2020, Feb 2020</li>
                                                    </ul>
                                            </div>
                                          </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="dayCardImg">
                            <div class="">
                                <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/award_kidzee_img.png" loading="lazy" alt="Kidzee Daycare"
                                    class="schoolGirlImg responsive" align="center">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="desktop_award">
                <div class="award_list d-flex justify-content-center align-items-center">

                        <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/kidzee-partner/footer_icon/aw1.png" width="100%" alt="">
                        <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/kidzee-partner/footer_icon/aw2.png" width="100%" alt="">
                        <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/kidzee-partner/footer_icon/aw3.png" width="100%" alt="">
                        <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/kidzee-partner/footer_icon/aw4.png" width="100%" alt="">
                        <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/kidzee-partner/footer_icon/aw5.png" width="100%" alt="">
                        <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/kidzee-partner/footer_icon/aw6.png" width="100%" alt="">
                        <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/kidzee-partner/footer_icon/aw7.png" width="100%" alt="">
                        <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/kidzee-partner/footer_icon/aw8.png" width="100%" alt="">
                        <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/kidzee-partner/footer_icon/aw9.png" width="100%" alt="">                  
                </div>
            </div>
<div class="mobile_award">
                <owl-carousel-o [options]="customOptions1">
                    <ng-template carouselSlide> <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/kidzee-partner/footer_icon/aw1.png" width="100%" alt=""></ng-template> 
                    <ng-template carouselSlide> <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/kidzee-partner/footer_icon/aw2.png" width="100%" alt=""></ng-template> 
                    <ng-template carouselSlide> <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/kidzee-partner/footer_icon/aw3.png" width="100%" alt=""></ng-template> 
                    <ng-template carouselSlide> <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/kidzee-partner/footer_icon/aw4.png" width="100%" alt=""></ng-template> 
                    <ng-template carouselSlide> <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/kidzee-partner/footer_icon/aw5.png" width="100%" alt=""></ng-template> 
                    <ng-template carouselSlide> <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/kidzee-partner/footer_icon/aw6.png" width="100%" alt=""></ng-template> 
                    <ng-template carouselSlide> <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/kidzee-partner/footer_icon/aw7.png" width="100%" alt=""></ng-template> 
                    <ng-template carouselSlide> <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/kidzee-partner/footer_icon/aw8.png" width="100%" alt=""></ng-template> 
                    <ng-template carouselSlide> <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/kidzee-partner/footer_icon/aw9.png" width="100%" alt=""></ng-template> 
                  </owl-carousel-o>
                </div>
            </div>
        </div>
    </div>
</section>


<section>
    <div class="sub_content padding_top">
        <div class="gallery_content">
            <h1 class="title text-center">
                Gallery<br>
                <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/bottom_img.png" class="kidzee_bottom_img" alt="">
            </h1>
            <div class="desktop_gallery">
            <div class="row">
                <div class="col-md-3">
                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/g1.png" width="100%" alt="">
                </div>
                <div class="col-md-3">
                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/g2.png" width="100%" alt="">
                </div>
                <div class="col-md-3">
                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/g3.png" width="100%" alt="">
                </div>
                <div class="col-md-3">
                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/g4.png" width="100%" alt="">
                </div>
                <div class="col-md-3">
                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/g5.png" width="100%" alt="">
                </div>
                <div class="col-md-3">
                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/g6.png" width="100%" alt="">
                </div>
                <div class="col-md-3">
                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/g7.png" width="100%" alt="">
                </div>
                <div class="col-md-3">
                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/g8.png" width="100%" alt="">
                </div>
            </div>
        </div>
            <div class="row mobile_gallery">
                      <owl-carousel-o [options]="customOptions">
                        <ng-template carouselSlide><img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/g1.png" width="100%" alt=""></ng-template>  
                        <ng-template carouselSlide><img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/g2.png" width="100%" alt=""></ng-template>  
                        <ng-template carouselSlide><img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/g3.png" width="100%" alt=""></ng-template> 
                        <ng-template carouselSlide><img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/g4.png" width="100%" alt=""></ng-template>  
                        <ng-template carouselSlide><img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/g5.png" width="100%" alt=""></ng-template>  
                        <ng-template carouselSlide><img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/g6.png" width="100%" alt=""></ng-template> 
                        <ng-template carouselSlide><img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/g7.png" width="100%" alt=""></ng-template>  
                        <ng-template carouselSlide><img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/g8.png" width="100%" alt=""></ng-template>  
                      </owl-carousel-o>
            </div>
        </div>

    </div>
</section>


<section id="faqs">
    <div class="mainDiv5">
        <div class="sub_content padding_top">
        <div class="">
            <div class="faq_content">
                <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/dall_girl.png" class="dall_girl_content" alt="">
                <div class="sub_faq_content">
                <h1 class="title text-center">
                    FAQs
                </h1>
                <div class="row">
                    <div class="col-md-12">
                        <div class="leftFaqs">
                            <mat-accordion>
                                <mat-expansion-panel>
                                        <mat-expansion-panel-header>
                                            How much do I need to invest to open a Kidzee Preschool franchise?
                                        </mat-expansion-panel-header>
                                        <div class="faq_sub_content">
                                            <span>To establish a Kidzee Preschool franchise, the required investment typically ranges between INR ₹15-25 lakhs. The final amount may vary depending on the location, size of the center, and specific city where you plan to set up the franchise.</span>
                                        </div>
                                            </mat-expansion-panel>
                                <mat-expansion-panel>
                                    <mat-expansion-panel-header>
                                        Will Kidzee help me in setting up the infrastructure and ensuring a safe, child-friendly environment at my Preschool?
                                    </mat-expansion-panel-header>
                                    <div class="faq_sub_content">
                                    <span>Yes, Kidzee provides comprehensive support in setting up your Preschool. We offer a Kidzee Ambiance Manual, which details the aesthetic and design standards for your center, ensuring it follows our uniform, child-centric guidelines.</span>
                                </div>
                                </mat-expansion-panel>

                            <mat-expansion-panel>
                                <mat-expansion-panel-header>
                                   Can Kidzee assist with creating the right ambiance?
                                </mat-expansion-panel-header>
                                <div class="faq_sub_content">
                                <span>Yes, your center’s interiors should be designed according to the standards to create a welcoming, engaging, and safe learning environment.In addition, we provide you with essential school supplies, including teaching kits, curriculum materials, learning resources, books, educational toys, and more, ensuring that your Preschool is fully equipped right from day one.</span>
                            </div>
                            </mat-expansion-panel>

                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                Where can I source the necessary equipment, books, toys, and other materials required for my Preschool?
                            </mat-expansion-panel-header>
                            <div class="faq_sub_content">
                                <span>We assist in procuring books, toys, learning kits, furniture, and more, all aligned with the Kidzee standards. Additionally, we offer exclusive deals and packages to ensure consistency in the quality of products used across all centers.</span>
                            </div>
                              </mat-expansion-panel>

                    <mat-expansion-panel>
                        <mat-expansion-panel-header>
                            I am new to running a Preschool franchise. How will I manage the day-to-day operations at my new Kidzee Preschool?
                        </mat-expansion-panel-header>
                        <div class="faq_sub_content">
                        <span>At Kidzee, we understand that running a Preschool is a new venture for many franchisees. To help you navigate this process, we provide comprehensive training and induction programs. Our Standard Operating Procedures (SOP) Manual simplifies daily tasks by providing clear instructions on:</span>
                    </div>
                        <ul class="faq_list_li mt-3">
                            <li>Managing enrollments and queries</li>
                            <li>Fee collection processes</li>
                            <li>Curriculum delivery</li>
                            <li>Safety and hygiene protocols</li>
                            <li>Financial management and accounting</li>
                            <li>Staff training and much more</li>
                            <li>Moreover, our dedicated support team is always available to assist you with any operational challenges you may encounter, ensuring smooth day-to-day management.</li>
                        </ul>
                </mat-expansion-panel>

                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        How do I determine if a location is suitable for opening a Kidzee Preschool franchise?
                    </mat-expansion-panel-header>
                    <div class="faq_sub_content">
                    <span>Kidzee provides expert guidance on selecting the best location for your Preschool. We have representatives in key cities who can help you assess the demographics, foot traffic, and local demand for early childhood education. With their extensive experience and insights, they will help you choose a location that maximizes growth potential and ensures the success of your center.</span>
                </div>
                </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    How many staff members and other personnel will I need to run a Kidzee Preschool?
                </mat-expansion-panel-header>
                <div class="faq_sub_content">
                <span >The required number of staff will depend on the enrollment and the size of your center. Kidzee maintains a recommended child-to-teacher ratio of 1:10, ensuring that each child receives personal attention. This staffing structure ensures optimal care, education, and safety for all children attending your Preschool.</span>
            </div>
            </mat-expansion-panel>

                            </mat-accordion>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </div>
    </div>
</section>
</div>

<!-- <section>
    <div class="mainDiv6">
        <div class="blogsContent">
            <app-blogs></app-blogs>
        </div>
    </div>
</section> -->


<section id="testimonials">
    <div class="testimonial_content">
        <div class="sub_content padding_top">
            <h1 class="title text-center">
                Testimonials<br>
                <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/bottom_img.png" class="kidzee_bottom_img" alt="">
            </h1>
        <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
            <!-- <div class="carousel-indicators">
              <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
              <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
              <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
            </div> -->
            <div class="carousel-inner">
              <div class="carousel-item active">
                <div class="testimonial_sub_content">
                    <h5 class="text-center">Rakhi Gupta</h5>
                    <p class="mt-3 text-center">Starting a Kidzee preschool transformed my life. It has helped me with new philosophies, new learnings and new trainings. Holistic learning is the biggest strength of Kidzee and learning is an engaging experience.</p>
                </div>
              </div>
              <div class="carousel-item">
                <div class="testimonial_sub_content">
                    <h6 class="text-center">Lalitha Rao</h6>
                    <p class="mt-3 text-center">Earlier as a housewife I was not very confident on running my own school, there were lot of questions. Kidzee helped me through the entire process. It provides a very good platform.</p>
                </div>
              </div>
            </div>
            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
    </div>
</section>

<section>
    <footer class="">
        <div class="footerContent">
            <div class="footer_sub_content">
            <div class="row py-5">
                <div class="col-md-4 d-flex">
                    <div class="footer_left right_border">
                        <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/kidzee_yellow.png" width="100%" alt="">
                    </div>
                    <div class="footer_left">
                        <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/zeeLearn_logo.png" width="100%" alt="">
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="content_content">
                        <!-- <h6 class="text-white">For Admissions Enquiry,</h6> -->
                        <div class="mt-2">
                        <p class="text-white m-2">
                            <img class="contect_icon" src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/kidzee-partner/footer_icon/Phone.png"><a  class="text-white m-0" href="tel:+919320063100">+91 93200 63100</a></p>
                        <p class="text-white m-2"><img class="contect_icon" src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/kidzee-partner/footer_icon/Mail.png">franchise&#64;kidzee.com</p>
                        <p class="text-white m-2"><img class="contect_icon" src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/kidzee-partner/footer_icon/Clock.png">Monday to Friday - 10 a.m. to 6 p.m.</p>
                    </div>
                </div>
                </div>
                <div class="col-md-4">
                    <div class="location_content d-flex">
                        <img class="contect_icon" src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/kidzee-partner/footer_icon/location.png" height="20px" alt="">
                        <p>Zee Learn Limited, 135, Continental Building,B wing, Worli, Mumbai, Maharashtra 400018.</p>
                    </div>
                    <div class="midea_content">
                        <a href="https://www.facebook.com/KidzeeIndia" target="_blank"><img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/fb.png" width="20px" height="20px" alt=""></a>
                        <a href="https://www.instagram.com/kidzeeindia/" target="_blank"><img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/insta.png" class="mx-2" width="20px" height="20px" alt=""></a>
                        <a href="https://www.youtube.com/@KidzeeIndia" target="_blank"><img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/youtube.png" class="mx-2" width="20px" height="20px" alt=""></a>
                    </div>
                </div>
            </div>
           
        </div>
    </div>
    <div class="footer_year_text_content">
    <div class="row">
        <div class="col-md-12">
            <div class="text-white text-center footerTextEmailId">
                Copyright © 2025 Zee Learn Ltd. | T&C | Privacy Policy | Disclaimer
            </div>
        </div>
    </div>
</div>
    </footer>
</section>

  <div id="popup2" class="popup" *ngIf="isPopupVisible">
    <div class="popup-content">
        <div class="row">
            <div class="col-12 d-flex justify-content-end">
            <button class="btn btn-sm btn-danger close_btn" (click)="closePopup()"><i class="fa fa-close"></i></button>
    </div>
    </div>
        <div class="poup_text_content">
            <div class="row">
                <div class="col-2 d-flex justify-content-center align-items-center">
                    <img src="{{popupObjList[0].icon}}" alt="">
                </div>
                <div class="col-10 d-flex justify-content-start align-items-center">
                    <div class="advantage_text">
                        <h5>{{popupObjList[0].title}}</h5>
                    </div>
                </div>
                <div class="col-12 mt-2">
                    <p>{{popupObjList[0].text}}</p>
                </div>
            </div>
        </div>
     
    </div>
  </div>